import React from "react";
import PropTypes from "prop-types";

// Font Awesome Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * This component renders the icon from returning a FontAwesomeIcon component.
 *
 * @origin https://github.com/FortAwesome/react-fontawesome
 * @origin https://docs.fontawesome.com/web/use-with/react/add-icons
 *
 * @param {Object} props - The object containing props.
 * @param {string} props.containerClass - only used with fixedWidth, don't add margin to the icon class.
 * @param {string} props.fixedWidth - the width should be about 1rem larger than the size of icon, e.g. icon=1rem width=2rem, icon=2rem, width=3rem.
 * @param {string} props.class - classes applied to the FontAwesomeIcon component.
 * @param {string} props.lib - optional lib like the default "fal".
 * @param {string} props.name - required icon name from available at FontAwesomeIcon and defined in global-layout.js.
 * @param {string} props.title - text to show at the tooltip when hover the icon, if not defined it will use the name.
 * @returns {React.JSX.Element} Returns the JSX component to render.
 */
const Icon = ({
  containerClass = "mr-2", // only used with fixedWidth, don't add margin to the icon class
  fixedWidth = "", // the width should be about 1rem larger than the size of icon, e.g. icon=1rem width=2rem, icon=2rem, width=3rem
  class: className = "",
  lib = "fal",
  name = "money-bill-wave",
  title = "", // optional, used to render a tooltip for the icon and its svg title `<FontAwesomeIcon title={title} />`
  style = {}
}) => {
  return (
    <>
      {fixedWidth ? (
        <span className={`text-center d-inline-block ${containerClass}`} style={{ width: fixedWidth }}>
          <FontAwesomeIcon
            title={title || name}
            className={className}
            icon={[`${lib}`, `${name}`]}
            role="presentation"
            style={style}
          />
        </span>
      ) : (
        <FontAwesomeIcon
          title={title || name}
          className={className}
          icon={[`${lib}`, `${name}`]}
          role="presentation"
          style={style}
        />
      )}
    </>
  );
};
export default Icon;

Icon.propTypes = {
  containerClass: PropTypes.string, // only used with fixedWidth, don't add margin to the icon class
  fixedWidth: PropTypes.string, // the width should be about 1rem larger than the size of icon, e.g. icon=1rem width=2rem, icon=2rem, width=3rem
  class: PropTypes.string,
  lib: PropTypes.string,
  name: PropTypes.string.isRequired,
  title: PropTypes.string
};
